export default __webpack_public_path__ + "static/media/instacartlogo.8f4290f8.svg";